import { getCartSectionsToRender } from './get-sections'

/**
 * Dissect product form
 *
 * @param formData {Object}
 *
 * @returns {string|null}
 */
const dissectForm = (formData) => {
  // If variant ID is not present abort mission.
  if (formData.productVariant) {
    const defaultQuantity = 1

    // Collect all the data.
    const variantID = formData.productVariant
    const quantity = formData.quantity ? formData.quantity : defaultQuantity
    let quantityValue = 1
    if (quantity === 'single') {
      quantityValue = 1
    } else if (quantity === 'pair') {
      quantityValue = 2
    }

    // Create the basic data object.
    const data = {
      id: variantID,
      quantity: quantityValue,
      properties: {},
      sections: getCartSectionsToRender().map((section) => section.id),
    }

    // Created the properties object.
    Object.entries(formData).map(([key, value]) => {
      data.properties['_' + key] = value
    })

    // Return a stringified JSON with the data of the product.
    return JSON.stringify(data)
  }

  // Return null if there is no variant id.
  return null
}

export { dissectForm }
